/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object } from 'prop-types';
import Grid from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';
import DesktopOrderFooter from './OrderDetailPlants/DesktopOrderFooter';
import DesktopOrderHeader from './OrderDetailPlants/DesktopOrderHeader';
import DesktopOrderListItem from './OrderDetailPlants/DesktopOrderListItem';
import { DesktopTrackOrderStyle } from '../../style/DesktopTrackOrderStyle';

class DesktopOrderDetailsByEmail extends React.PureComponent {
    render() {
        /* eslint-disable react/jsx-props-no-spreading */
        return (
            <Grid container direction="column" className={this.props.classes.DesktopTrackOrderStyle}>
                <DesktopOrderHeader {...this.props} />
                <DesktopOrderListItem {...this.props} />
                <DesktopOrderFooter {...this.props} />
            </Grid>
        );
    }
}

DesktopOrderDetailsByEmail.propTypes = {
    classes: object.isRequired,
};

export default withStyles(DesktopTrackOrderStyle)(DesktopOrderDetailsByEmail);
